export default __webpack_public_path__ + "static/media/transport.2424371f.svg";